import { Http, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import API from '@aws-amplify/api';


export class ApiService {

  constructor(
    private http: Http,
  ) {
   }

  public makeHeader() {
    let headers = new Headers();
    //headers.append('authorization', JSON.parse(localStorage.getItem('userDetails')).token);
    return { headers: headers };
  }

  public authHeader() {
    let headers = new Headers();
    headers.append('authorization', JSON.parse(localStorage.getItem('userDetails')).token);
    return { headers: headers };
  }

  public getCall(api,link) {
    let apiName = api
    let myInit = {
      headers: {
        authorization: JSON.parse(localStorage.getItem('userDetails')).token
      }
    }
    return Observable.fromPromise(API.get(apiName, link, myInit)).catch(this.handleError);
  }

  public getLocalCall(link) {
    let apiName = 'localForm'
    let myInit = {
      headers: {}
    }
    return Observable.fromPromise(API.get(apiName, link, myInit)).catch(this.handleError);
  }

  // only use this if you have to like with downloading a file
  // everything else should use the other one.
  public getCallNoJSON(api,link) {
    let apiName = api
    let myInit = {
      headers: {}
    }
    return Observable.fromPromise(API.get(apiName, link, myInit)).catch(this.handleError);
  }

  public postCall(api,link, data) {
    let apiName = api
    let path = link;
    let myInit = {
      body: data,
      headers: {
        authorization: JSON.parse(localStorage.getItem('userDetails')).token
      }
    }
    return Observable.fromPromise(API.post(apiName, path, myInit)).catch(this.handleError);
  }
  // this is for presign
  public putCallPreSign(api,link, data) {
    let apiName = api;
    let path = link;
    let myInit = {
      body: data,
      headers: {
        authorization: JSON.parse(localStorage.getItem('userDetails')).token
      }
    }
    return Observable.fromPromise(API.put(apiName, path, myInit)).catch(this.handleError);
  }


  public putCall(api,link, data?) {
    let apiName = api
    let path = link;
    let myInit = {
      body: data,
      headers: {
        authorization: JSON.parse(localStorage.getItem('userDetails')).token
      }
    }
    return Observable.fromPromise(API.put(apiName, path, myInit)).catch(this.handleError);
  }

  // public patchCall(api, link, data) {
  //   let apiName = api
  //   let path = link;
  //   let myInit = {
  //     body: data,
  //     headers: this.makeHeader()
  //   }
  //   return Observable.fromPromise(API.put(apiName, path, myInit)).catch(this.handleError);
  // }
  public patchCall(link, data) {
    return this.http.put(link, data, this.makeHeader())
      .map((result) => result.status)
      .catch(this.handleError);
  }

  public patchCallUser(link, data) {
    return this.http.put(link, data, this.authHeader())
      .map((result) => result.status)
      .catch(this.handleError);
  }

  public deleteCall(api,link) {
    let apiName = api
    let myInit = {
      headers: {
        authorization: JSON.parse(localStorage.getItem('userDetails')).token
      }
    }
    return Observable.fromPromise(API.del(apiName, link, myInit)).catch(this.handleError);
  }

  private handleError(error: any) {
    return Observable.throw(error || 'Server error');
  }

}



// WEBPACK FOOTER //
// ./src/app/main/shared/services/api.service.ts